module.exports = __webpack_public_path__ + "img/secB.c9ef50cf.png";